import React from 'react';
import { EC_Modal, UI_Modal, UI_Modal_project } from "../../UiComponents/index";
import './Dashboard.css';


function UserInputModal(props) {
    const {
        newProjectInputModalOpen,
        setNewProjectInputModalOpen,
        renameModal,
        setRenameModal,
        projectName,
        setProjectName,
        handleNewProjectName,
        handleRenameProjec,
    } = props;
    const disabled = newProjectInputModalOpen ? !projectName : !renameModal?.title
    const handleKeypress = e => {
        if (e.key === "Enter" && (e.code === "Enter" || e.code=== "NumpadEnter")) {
            newProjectInputModalOpen ? handleNewProjectName() : handleRenameProjec()
        }
    };
    return (
        <>
            <UI_Modal_project
                isOpen={newProjectInputModalOpen ? newProjectInputModalOpen : renameModal?.isOpen}
                closeModal={() => newProjectInputModalOpen ? setNewProjectInputModalOpen(false) : setRenameModal(prev => ({ ...prev, isOpen: false }))}
                title={newProjectInputModalOpen ? "Create Project" : "Rename Project"}
            >
                <div className="flex px-2 py-2  m-2 items-start text-white">
                    {/* <div className="basis-1/6 mt-4"></div> */}
                    <div className="w-full">
                        <input
                            type="text"
                            className="w-full  mt-[0px] p-1 px-2 user_input placeholder:text-white placeholder:FontFamily-Avenir-reg"
                            value={newProjectInputModalOpen ? projectName : renameModal?.title}
                            placeholder="Enter project name"
                            onChange={(e) => {
                                if (newProjectInputModalOpen) {
                                    setProjectName(e.target.value)
                                } else {
                                    setRenameModal(prev => ({ ...prev, title: e.target.value }))
                                }
                            }
                            }
                            onKeyDown={handleKeypress}
                        />
                    </div>
                </div>
                <div className="flex justify-center items-center pt-3 ">
                    <div className='w-[190px]  flex flex-row justify-between'>
                    <button className="cancel_btn_ui text-lg "
                        onClick={() => {
                            newProjectInputModalOpen ? setNewProjectInputModalOpen(false) : setRenameModal(prev => ({ ...prev, isOpen: false }))
                            setProjectName("");
                            setRenameModal(prev => ({ ...prev, title: "" }))
                        }}
                    >Cancel</button>
                    <button className="submit_btn_ui text-lg"
                        onClick={newProjectInputModalOpen ? handleNewProjectName : handleRenameProjec}
                        disabled={disabled}
                    >Create</button>
                    </div>
                </div>
            </UI_Modal_project>
        </>
    )
}

export default UserInputModal